var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* eslint-disable indent */
import styled, { css } from 'styled-components';
import { pxToRem } from "../../utils";
var StyledSpinnerSvgCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var $inverse = _ref.$inverse,
    $size = _ref.$size,
    theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: ", "rem;\n    color: ", ";\n    fill: currentColor;\n    width: ", "rem;\n\n    ", "\n  "])), pxToRem(56), $inverse ? theme.color_icon_inverse_default_1 : theme.color_icon_default_1, pxToRem(56), $size === 'small' && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      width: ", "rem;\n      height: ", "rem;\n    "])), pxToRem(24), pxToRem(24)));
});
export var StyledSpinnerSvg = styled.svg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.cssPrefix;
}, StyledSpinnerSvgCss);
export default styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", " {\n    text-align: center;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.cssPrefix;
});